import { createRoot } from 'react-dom/client'
import { App } from './App';
import * as Sentry from "@sentry/react"

Sentry.init({
	dsn: process.env.REACT_APP_SENTRY_DSN,
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true,
	environment: process.env.REACT_APP_CARDAMOMO_ENV,
	ignoreErrors: [/Failed to load Stripe\.js/],
});

const container = document.getElementById("root");
const root = createRoot(container!);
// DB intervention: set back to false when done
const MAINTENANCE = false;
if (MAINTENANCE) document.body.classList.add(`v${process.env.REACT_APP_VENUE_ID}`);
root.render(<Sentry.ErrorBoundary>{MAINTENANCE
	? <div className="maintenance">
		<div className="maintenance-card">
			<span className="maintenance-dot" />
			<h1>System under maintenance</h1>
			<p>We're doing some work on our booking system. Please come back later.</p>
		</div>
	</div>
	: <App />}</Sentry.ErrorBoundary>)
